import React from 'react';
import { BuyButton } from './ui/BuyButton';
export function FinalCta() {
  return <section className="w-full bg-sage-800 px-5 py-20 sm:px-8 lg:py-28" data-id="element-51" data-mp="vf6694i943nv">
      <div className="mx-auto max-w-2xl text-center" data-id="element-52" data-mp="vhaic9qb08z8">
        <p className="flex items-center justify-center gap-3 text-[11px] font-semibold uppercase tracking-overline text-gold-200" data-id="element-53" data-mp="19g0dvkxh60lh">
          <span className="h-px w-7 bg-gold-400/50" aria-hidden="true" data-id="element-54" data-mp="15c2ct4olafps" />
          Empezá hoy
          <span className="h-px w-7 bg-gold-400/50" aria-hidden="true" data-id="element-55" data-mp="1jbk4psx6m93d" />
        </p>
        <h2 className="mt-5 font-serif text-[2.4rem] leading-[1.04] text-cream sm:text-5xl lg:text-[3.5rem]" data-id="element-56" data-mp="1ed8wtnqg68ns">
          Hoy podés empezar a crear algo{' '}
          <span className="italic text-gold-200" data-id="element-57" data-mp="1o43kmwjcdgbc">hermoso con flores reales</span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-[16px] leading-relaxed text-sage-100" data-id="element-58" data-mp="223mhgt6pd58c">
          Con el método correcto, crear con flores prensadas deja de ser{' '}
          <strong className="font-semibold text-cream" data-id="element-59" data-mp="1x6cv5mem19oq">prueba y error</strong> y se
          transforma en una experiencia creativa, relajante y llena de posibilidades.
        </p>
        <div className="mt-10 flex flex-col items-center gap-3" data-id="element-60" data-mp="s5gyc92qozoi">
          <BuyButton size="xl" variant="gold" label="Quiero mi guía Deco Flores" className="w-full sm:w-auto" data-id="element-61" data-mp="x390dvx3m26f" />
          <p className="text-[12.5px] text-sage-200" data-id="element-62" data-mp="123537ru27nke">
            Producto digital · acceso inmediato
          </p>
        </div>
      </div>
    </section>;
}